import { useEffect, useState } from "react"
import { func, shape, string } from "prop-types"
import { DateTimeContainer } from "components/admin/Event/SignUpDatesAndTimes"
import moment from "moment-timezone"

const SignupPurposeStep = ({
  event = {},
  setEvent = () => {},
  setNextButtonDisabled = () => {},
  onSignupPurposeChange = () => {},
  signupPurpose = "specific"
}) => {
  const eventTime = event.eventTimes[0]
  const [initialEventTime] = useState(event.eventTimes[0])

  useEffect(() => {
    setNextButtonDisabled(
      !!eventTime && (!moment(eventTime.startsAt).isValid() || !moment(eventTime.endsAt).isValid())
    )
  }, [eventTime?.startsAt, eventTime?.endsAt])

  const handleEventTimeChange = (_key, payload) => {
    setEvent(prevEvent => ({
      ...prevEvent,
      eventTimes: [{ ...prevEvent.eventTimes[0], ...payload }]
    }))
  }

  const handleSignupPurposeChange = purpose => {
    onSignupPurposeChange(purpose)

    if (purpose == "ongoing") {
      setEvent(prevEvent => ({ ...prevEvent, eventTimes: [] }))
      setNextButtonDisabled(false)
    } else {
      setEvent(prevEvent => ({ ...prevEvent, eventTimes: [initialEventTime] }))
    }
  }

  return (
    <div>
      <>
        <h2 className="mb-3">What are you creating a signup for?</h2>
        <div>
          <input
            id="ongoing"
            name="purpose_select"
            className="radio"
            type="radio"
            value="ongoing"
            onClick={() => handleSignupPurposeChange("ongoing")}
            defaultChecked={signupPurpose == "ongoing"}
          />
          <label className="radio-label" htmlFor="ongoing">
            An ongoing program or opportunity
          </label>
        </div>
        <div className="mt-1">
          <input
            id="specific"
            name="purpose_select"
            className="radio"
            type="radio"
            value="specific"
            onClick={() => handleSignupPurposeChange("specific")}
            defaultChecked={signupPurpose == "specific"}
          />
          <label className="radio-label" htmlFor="specific">
            An event on a specific date
          </label>
        </div>
      </>

      {signupPurpose == "specific" && (
        <div className="mt-3">
          <DateTimeContainer
            eventTime={eventTime}
            canDeleteAllEventTimes={false}
            onlyEventTime={true}
            mobileBrowser={window.isMobile}
            onChange={handleEventTimeChange}
            twentyFourHourTime={App.currentOrganization.twentyFourHourTime}
          />
          <p className="font-size-4 mt-1 c-neutral-400">
            You can add additional dates and times after you create the event.
          </p>
        </div>
      )}
    </div>
  )
}

SignupPurposeStep.propTypes = {
  organization: shape({}),
  event: shape({}),
  onSignupPurposeChange: func,
  setEvent: func,
  setNextButtonDisabled: func,
  signupPurpose: string
}

export default SignupPurposeStep
